import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../providers/ApiProvider';

export function useSingleUser({
  enabled = true,
  phonenumber,
}: {
  enabled?: boolean;
  phonenumber:string;
}) {
  const api = useApi();

  return useQuery({
    queryKey: ['users', phonenumber], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: `users/${phonenumber}`,
      });
      return res;
    },
    enabled,
  });
}
